import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PrivacyType } from '@weblite/ts-action/user-policy'
import { RemoveIcon } from '$common/icons/remove'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { removeFromOpenedUserList } from '$logic/opened-user-list'
import { removeUserPolicy } from '$logic/user-policy'
import { t } from '$i18n'

interface Props {
  userId: string
  isOpen: boolean
  privacyType: PrivacyType
}

export function DeleteExceptionUserMenu({
  userId,
  isOpen,
  privacyType,
}: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.exceptionUser.removeFromList')}
        onClick={async () => {
          await removeUserPolicy([userId], privacyType)
          removeFromOpenedUserList(userId)
          closeCurrentModal()
        }}
      >
        <RemoveIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}

// removeUserPolicy([userId], 'ADD_HALL')
